module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网新闻")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('p', {
    staticClass: "formTitle"
  }, [_vm._v("新闻信息")]), _vm._v(" "), _c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("封面图")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.formItem.titleImgUrl
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("主标题")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.mainTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "mainTitle", $$v)
      },
      expression: "formItem.mainTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("来源")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.source),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "source", $$v)
      },
      expression: "formItem.source"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("新闻类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.newsCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "newsCategory", $$v)
      },
      expression: "formItem.newsCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("公司新闻")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("行业动态")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("媒体报导")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.summary),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "summary", $$v)
      },
      expression: "formItem.summary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详细内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "readonly": "",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请输入详细内容..."
    },
    model: {
      value: (_vm.formItem.content),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "content", $$v)
      },
      expression: "formItem.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editNewsInfo(_vm.formItem.id)
      }
    }
  }, [_vm._v("编辑新闻")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a884d44","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/material-blocks/newsInfo.vue
// module id = +Mdo
// module chunks = 0